<app-image [width]="'48px'" [height]="'48px'" [maxWidth]="'48px'" style="margin-left: 16px;" [src]="profileImage" [class]="'profile'" class="cursor" *ngIf="!viewChange"></app-image>

<div *ngIf="viewChange" class="profile bg-s0 cursor">
    <app-image [width]="'48px'" [height]="'48px'" [maxWidth]="'48px'" [src]="profileImage" [class]="'profile'"></app-image>
</div>